import { monthSort } from "./constant";

export const formatDate = (date) => {
  if (!date) return "-";
  const d = new Date(date);
  return `${String(d.getDate()).padStart(2, "0")}/${String(
    d.getMonth() + 1
  ).padStart(2, "0")}/${String(d.getFullYear())}`;
};

export const formatDateToDDMMYYYY = (dateValue) => {
  if (!dateValue) return "-";

  const rawDate = String(dateValue).trim();
  if (!rawDate) return "-";

  // Keep already formatted dd-mm-yyyy values as-is.
  if (/^\d{2}-\d{2}-\d{4}$/.test(rawDate)) {
    return rawDate;
  }

  const normalizedDate = rawDate.includes("T")
    ? rawDate.split("T")[0]
    : rawDate;
  const date = new Date(normalizedDate);

  if (Number.isNaN(date.getTime())) {
    return rawDate;
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export const generateMonthArray = (from, to) => {
  let months = [];
  let { month: startMonth, year: startYear } = from;
  let { month: endMonth, year: endYear } = to;

  while (
    startYear < endYear ||
    (startYear === endYear && startMonth <= endMonth)
  ) {
    months.push(
      `${monthSort[startMonth - 1]}'${startYear.toString().slice(-2)}`
    );

    startMonth++;
    if (startMonth > 12) {
      startMonth = 1;
      startYear++;
    }
  }

  return months;
};

export const getMonthCount = (fromDate, toDate) => {
  return (
    (toDate.year - fromDate.year) * 12 + (toDate.month - fromDate.month) + 1
  );
};

export const formatDateMonth = (date) => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const dateObj = new Date(date);
  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = months[dateObj.getMonth()];
  const year = dateObj.getFullYear();

  return `${day} ${month} ${year}`;
};
